import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { TextField } from '@habitech/keychain-atoms-inputs';
import { Button, DropdownButton } from '@habitech/call-to-action';
import { Toggle, RadioButton } from '@habitech/selectors';
import { GridItem } from 'src/components/common/grids';
import { Container, Title, SearchWrapper, UploadButton, WrapperButton, TextModal } from './styles';
import Loading from '../common/Loading/Loading';
import Modal from '../common/modal/Modal';
import ImageUploader from './ImageUploader';
import ProcessList from './ProcessList';
import { useAppDispatch } from 'src/hooks/redux';
import { getAnalogGalleries, getAnalogInventoryProcessList, postAnalog } from 'src/redux/analog_inventory/thunks';
import { PostAnalogRequest } from 'src/redux/analog_inventory/state';

const is = {
    yes: 1,
    no: 0,
};


const initialValues = {
    name: '',
    user_name: '',
    user_email: '',
    contact_email: '',
    contact_phone: '',
    is_whatsapp: is.no,
    gallery_id: '',
    is_auction: is.no,
    file_csv: '',
};

const AnalogLoad = () => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const [listGallery, setListGallery] = useState([]);
    const [fileCSV, setFileCSV] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [newGallery, setNewGallery] = useState(0);

    const validationSchema = yup.object({
        user_name: yup.string().required('Debe escribir un nombre de proceso'),
        name: yup.string().required('Debe escribir un nombre de usuario'),
        user_email: yup.string().email('Correo electrónico inválido').required('Debe escribir un correo de usuario'),
        contact_email: yup.string().email('Correo electrónico inválido'),
        contact_phone: yup
            .number()
            .max(999999999999999, 'El teléfono no debe ser menor a 15 dígitos')
            .min(999999999, 'debe ser mayor a 10 dígitos'),
        gallery_id: yup.string().required('Debe seleccionar una galería').notOneOf(['nueva'], 'no es valido'),
        file_csv: yup
            .mixed()
            .test('tipo-archivo', 'Solo se permiten archivos CSV', (value: any) => {
                // Validar el tipo de archivo
                return value && value.type === 'text/csv';
            })
            .required('Debe seleccionar un archivo CSV'),
    });

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema,
        onSubmit: (values: any) => {
            const data: PostAnalogRequest = {
                ...values,
                file_csv: fileCSV,
            };
            setLoading(true);
            dispatch(postAnalog({ data })).unwrap().then((res) => {
                setShowModal(true);
                setLoading(false);
            })
                .catch((e) => console.error(e));
        },
    });

    const handleFileUpload = (event) => {
        event.preventDefault();
        let files;
        if (event.target.files || event.dataTransfer.files) {
            files = event.target.files ?? event.dataTransfer.files;
            files = files[0];
        }

        formik.setFieldValue('file_csv', files);
        const reader = new FileReader();
        reader.onload = () => {
            const binaryData = reader.result;
            setFileCSV(binaryData);
        };
        reader.readAsArrayBuffer(files);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        console.log('newGallery', newGallery);

        dispatch(getAnalogGalleries()).unwrap().then(async (res) => {
            await dispatch(getAnalogInventoryProcessList({})).unwrap();
            const data = res?.data?.map((item: any) => ({
                label: item.name,
                value: item.id,
            }));
            setListGallery(data);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newGallery]);

    return (
        <>
            <Container>
                <Title>Carga de inventario analogo</Title>
                <form onSubmit={formik.handleSubmit}>
                    <SearchWrapper>
                        <GridItem>
                            <TextField
                                dataId="name"
                                name="name"
                                label="Nombre de proceso"
                                originType="pcom"
                                placeHolder="Ingrese el nombre del proceso (Obligatorio)"
                                innerLabel
                                value={formik.values.name}
                                onChange={(_, _vale, e) => formik.handleChange(e)}
                                error={Boolean(formik.errors.name)}
                                errorMessage={JSON.stringify(formik.errors.name)}
                            />
                        </GridItem>
                        <GridItem>
                            <TextField
                                dataId="user_name"
                                name="user_name"
                                label="Nombre de usuario"
                                originType="pcom"
                                placeHolder="Ingrese el nombre del usuario (Obligatorio)"
                                innerLabel
                                value={formik.values.user_name}
                                onChange={(_, _vale, e) => formik.handleChange(e)}
                                error={Boolean(formik.errors.user_name)}
                                errorMessage={JSON.stringify(formik.errors.user_name)}
                            />
                        </GridItem>
                        <GridItem>
                            <TextField
                                dataId="user_email"
                                name="user_email"
                                label="Correo usuario"
                                originType="pcom"
                                placeHolder="Ingrese el correo del usuario (Obligatorio)"
                                innerLabel
                                value={formik.values.user_email}
                                onChange={(_, _v, e) => formik.handleChange(e)}
                                error={Boolean(formik.errors.user_email)}
                                errorMessage={JSON.stringify(formik.errors.user_email)}
                            />
                        </GridItem>

                        <GridItem>
                            <TextField
                                dataId="contact_email"
                                name="contact_email"
                                label="Correo contacto"
                                originType="pcom"
                                placeHolder="Ingrese el correo de contacto (Obligatorio)"
                                innerLabel
                                value={formik.values.contact_email}
                                onChange={(_, _v, e) => formik.handleChange(e)}
                                error={Boolean(formik.errors.contact_email)}
                                errorMessage={JSON.stringify(formik.errors.contact_email)}
                            />
                        </GridItem>

                        <GridItem sm={3} md={5} lg={7}>
                            <TextField
                                dataId="contact-phone"
                                name="contact_phone"
                                label="Telefono contacto"
                                originType="pcom"
                                placeHolder="Ingrese telefono de contacto (Obligatorio)"
                                innerLabel
                                type="number"
                                value={formik.values.contact_phone}
                                onChange={(_, _v, e) => formik.handleChange(e)}
                                error={Boolean(formik.errors.contact_phone)}
                                errorMessage={JSON.stringify(formik.errors.contact_phone)}
                            />
                        </GridItem>
                        <GridItem sm={3} md={3} lg={5}>
                            <Toggle
                                dataId="is_whatsapp"
                                name="is_whatsapp"
                                onToggle={(_, toogle) => formik.setFieldValue('is_whatsapp', toogle ? is.yes : is.no, false)}
                                originType="pcom"
                                value="is_whatsapp"
                                showLabel
                                selected={false}
                            />
                            <span>¿Es WhatsApp?</span>
                        </GridItem>
                        <GridItem sm={6} md={4} lg={6}>
                            <p>¿Es un remate bancario?</p>
                            <div style={{ display: 'flex', gap: '16px' }}>
                                <RadioButton
                                    dataId="is_auction"
                                    id="is_auction"
                                    name="is_auction"
                                    onChange={(e) => formik.setFieldValue('is_auction', Number(e))}
                                    originType="pcom"
                                    value={`${formik.values.is_auction}`}
                                    radioBtnList={[
                                        { label: 'Sí', value: `${is.yes}` },
                                        { label: 'No', value: `${is.no}` },
                                    ]}
                                    selected={`${is.no}`}
                                />
                            </div>
                        </GridItem>
                        <GridItem md={4} lg={6} className="dropdown-gallery">
                            <p>Seleccione la galería</p>
                            <DropdownButton
                                dataId="test_id"
                                listOptions={[
                                    {
                                        label: 'cargar nueva galería *',
                                        value: 'nueva',
                                    },
                                    ...listGallery,
                                ]}
                                originType="pcom"
                                placeholder="Seleccione"
                                setValue={(val: string) => formik.setFieldValue('gallery_id', val)}
                                size="fluid large"
                                value={formik.values.gallery_id}
                                variant="white"
                                error={Boolean(formik.errors.gallery_id)}
                                errorMessage={JSON.stringify(formik.errors.gallery_id)}
                            />
                            {formik.values.gallery_id === 'nueva' ? (
                                <ImageUploader setFieldValue={formik.setFieldValue} setNewGallery={setNewGallery} newGallery={newGallery} />
                            ) : (
                                ''
                            )}
                        </GridItem>

                        <GridItem>
                            <UploadButton
                                className={formik.values.gallery_id === 'nueva' ? 'disabled' : ''}
                                onDrop={handleFileUpload}
                                onDragOver={handleDragOver}
                            >
                                <label htmlFor="myfile" className={`drop-container ${formik.errors.file_csv ? 'error' : ''}`}>
                                    <input type="file" id="myfile" name="file_csv" onChange={handleFileUpload} />
                                    {!formik.values.file_csv?.name ? (
                                        <span className="drop-title">Arrastrar o subir archivo csv</span>
                                    ) : (
                                        <span>
                                            <b>Se ha subido el archivo: </b>
                                            {formik.values.file_csv?.name}
                                        </span>
                                    )}
                                </label>
                                {formik.errors.file_csv && formik.touched.file_csv && (
                                    <div className="error-text">{`* ${JSON.stringify(formik.errors.file_csv)}`}</div>
                                )}
                            </UploadButton>
                        </GridItem>
                    </SearchWrapper>
                    <WrapperButton>
                        {!loading ? (
                            <Button dataId="button-search" originType="pcom" size="large" type="submit" fluid>
                                Cargar inventario
                            </Button>
                        ) : (
                            <Loading height="80%" />
                        )}
                    </WrapperButton>
                </form>
                {showModal && (
                    <Modal onClose={() => setShowModal(false)}>
                        <TextModal>Se envío el inventario con exito...</TextModal>
                        <WrapperButton>
                            <Button dataId="button-search" originType="pcom" size="large" onClick={() => setShowModal(false)}>
                                Aceptar
                            </Button>
                        </WrapperButton>
                    </Modal>
                )}
            </Container>
            <ProcessList showModal={showModal} />
        </>
    );
};

export default AnalogLoad;
